import Immutable from "immutable";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

//smarter mering of actions for Immutable data
function mergeActionsNew(data = Immutable.fromJS({}), newData = Immutable.fromJS({})) {
    var currentActions = data.get("actions");
    var newActions = newData.get("actions");

    if (!currentActions) {
        return newData;
    }

    if (!newActions) {
        return newData.set("actions", currentActions);
    }

    currentActions.forEach(currentAction => {
        var isExistingAction = newActions.find(action => {
            var sameType = action.get("actionType") === currentAction.get("actionType");
            var sameId = action.get("id") === currentAction.get("id");
            return sameType && sameId;
        });

        if (!isExistingAction) {
            newActions = newActions.push(currentAction);
        }
    });

    return newData.set("actions", newActions);
}

//merging properties for immutable data
function mergeProperties(data, newData) {
    var currentProperties = data.get("properties");
    var newProperties = newData.get("properties");

    if (!currentProperties) {
        return newData;
    }

    if (!newProperties) {
        return newData.set("properties", currentProperties);
    }

    let mergedProperties = currentProperties.merge(newProperties);

    return newData.set("properties", mergedProperties);
}

//reusable method
function getStepIndex(state, payload = {}, stepName) {
    let stepIndex = -1;
    let steps = state.getIn([payload.widgetId, "entities"]) || [];

    if (payload.class) {
        stepIndex = steps.findIndex(step => {
            let stepClass = step.get("class").toJS();

            //temp solution for Extranet integration
            if (payload.class.length === 1) {
                return stepClass.includes(payload.class[0]);
            }

            return stepClass.every(className => {
                return payload.class.includes(className);
            });
        });
    } else if (stepName) {
        stepIndex = steps.findIndex(step => {
            return step.get("step") === stepName;
        });
    }

    return stepIndex;
}

function deleteErrors(stepData) {
    let entities = stepData.get("entities");
    if (entities) {
        entities = entities.filter(entity => {
            if (entity.get("class") && entity.get("class").includes("errors")) {
                return false;
            } else return true;
        });
        entities = entities.map(entity => {
            return deleteErrors(entity);
        });
        return stepData.merge({ entities: entities });
    } else return stepData;
}

export default {
    END_FLOW: (state, action) => {
        let widgetId = action.payload.widget;
        let widget = state.get(widgetId);
        if (widget) {
            return state.delete(widgetId);
        } else {
            return state;
        }
    },

    FLOW_SUCCESS: (state, action) => {
        let actionsInState = state.getIn([action.payload.widget, "actions"]);
        let actionsInPayload = action.payload.actions;
        if (actionsInPayload) {
            if (actionsInState && actionsInState.find) {
                actionsInPayload.forEach(item => {
                    if (!actionsInState.find(a => a.get("actionType") === item.actionType)) {
                        actionsInState = actionsInState.push(Immutable.fromJS(item));
                    }
                });
            } else {
                actionsInState = Immutable.fromJS(action.payload.actions);
            }
        }
        let entitiesInState = state.getIn([action.payload.widget, "entities"]);
        let entitiesInPayload = action.payload.entities;
        //new entity state should be manage for the cases where we have dynamic steps
        //during the flow process the payload entities can be with different length from current state entities
        let entitiesToSet = Immutable.List([]);
        if (entitiesInPayload) {
            if (entitiesInState && entitiesInState.findKey) {
                entitiesInPayload.forEach((item, index) => {
                    var key = entitiesInState.findKey(entity => {
                        var classifier =
                            entity.get && entity.get("class") ? entity.get("class") : [];
                        if (classifier.toJS) classifier = classifier.toJS();
                        return classifier.includes(item.class[0]);
                    });
                    let stepState;
                    if (typeof key === "undefined" || !~key) {
                        stepState = Immutable.fromJS(item);
                    } else {
                        stepState = entitiesInState.get(key);
                        if (stepState && stepState.merge) {
                            stepState = stepState.merge(Immutable.fromJS(item));
                        }
                    }
                    entitiesToSet = entitiesToSet.push(stepState);
                });
            } else {
                entitiesToSet = Immutable.fromJS(entitiesInPayload);
            }
        } else {
            entitiesToSet = entitiesInState;
        }

        let stateWithNewActions = state.setIn([action.payload.widget, "actions"], actionsInState);
        let stateWithNewEntities = stateWithNewActions.setIn(
            [action.payload.widget, "entities"],
            entitiesToSet
        );
        let stateWithNewProperties = stateWithNewEntities.setIn(
            [action.payload.widget, "properties"],
            Immutable.fromJS(action.payload.properties)
        );
        return stateWithNewProperties;
    },
    COMPLETE_FLOW_SUCCESS: (state, action) => {
        try {
            let widgetId = action.payload.widgetId || action.payload.widget;
            let widgetState = state.get(widgetId);

            let toSet = {};
            toSet.status =
                action.payload.properties && action.payload.properties.status
                    ? action.payload.properties.status
                    : "completed";
            toSet.messages = [];
            if (action.payload.entities && action.payload.entities.find) {
                let messages = action.payload.entities.find(item => {
                    return item.class.includes("messages");
                });
                if (messages && messages.entities) {
                    toSet.messages = messages.entities;
                }
            }
            widgetState = widgetState.merge(Immutable.fromJS(toSet));
            return state.setIn([widgetId], widgetState);
        } catch (e) {
            WEBUILogs.error(e.message);
            return state;
        }
    },
    CANCEL_FLOW_SUCCESS: (state, action) => {
        let widgetId = action.payload.widget || action.payload.widgetId;
        let widget = state.get(widgetId);
        if (widget) {
            return state.setIn(
                [widgetId],
                Immutable.fromJS({
                    status: action.payload.status || "cancelled"
                })
            );
        } else {
            return state;
        }
    },
    //reworked to be the same as STEP_POST_SUCCESS
    STEP_DATA_SUCCESS: (state, action) => {
        let stepData;
        let newStepData;
        let stepIndex;
        let stepName = action.payload.step;

        stepIndex = getStepIndex(state, action.payload, stepName);

        //New step can be added only on getAvailableSteps
        if (stepIndex === -1) {
            return state;
        }

        stepData = state.getIn([action.payload.widgetId, "entities", stepIndex]);

        newStepData = Immutable.fromJS(action.payload);

        //merging actions
        newStepData = mergeActionsNew(stepData, newStepData);
        //merging properties
        newStepData = mergeProperties(stepData, newStepData);

        //doing shallow merge for the rest properties
        return state.setIn(
            [action.payload.widgetId, "entities", stepIndex],
            stepData.merge(newStepData)
        );
    },
    //In case of empty response, continue with flow reqeusts
    //In case of errors, display errors and wait for use action
    STEP_POST_SUCCESS: (state, action) => {
        let isEmptyResponse = action.payload.isEmpty;
        let stepData;
        let newStepData;
        let stepName = action.payload.step;

        let stepIndex = getStepIndex(state, action.payload, stepName);

        if (stepIndex === -1) {
            return state;
        }

        stepData = state.getIn([action.payload.widgetId, "entities", stepIndex]);

        if (isEmptyResponse) {
            //in case of empty response remove all step contents
            //Warning: not clean solution
            // Here it should delete only the errors entity
            newStepData = deleteErrors(stepData);
        } else {
            newStepData = Immutable.fromJS(action.payload);

            newStepData = mergeActionsNew(stepData, newStepData);
            newStepData = mergeProperties(stepData, newStepData);
        }

        return state.setIn(
            [action.payload.widgetId, "entities", stepIndex],
            stepData.merge(newStepData)
        );
    },
    //In case of empty response, continue with flow reqeusts (do nothing)
    //In case of errors, display errors and wait for use action
    STEP_POST_ONLY_SUCCESS: (state, action) => {
        let isEmptyResponse = action.payload.isEmpty;
        let stepData;
        let newStepData;
        let stepName = action.payload.step;

        let stepIndex = getStepIndex(state, action.payload, stepName);

        if (stepIndex === -1) {
            return state;
        }

        stepData = state.getIn([action.payload.widgetId, "entities", stepIndex]);

        if (isEmptyResponse) {
            //do nothing
            return state;
        } else {
            //if a step is returned, save it to store
            //doing shallow merge
            //usecase: actions should be perserved but there can be errors, which can not be deep merged
            newStepData = stepData.merge(action.payload);
        }

        return state.setIn([action.payload.widgetId, "entities", stepIndex], newStepData);
    },
    SET_STEP_ATTRIBUTE: (state, action) => {
        var steps = state.getIn([action.payload.widgetId, "entities"]);
        if (steps) {
            var stepIndex = steps.findIndex(step => {
                let classifiers = step.get("class") ? step.get("class") : new Immutable.List([]);

                return classifiers.contains(action.payload.step);
            });
            if (stepIndex > -1) {
                var stepData = state.getIn([action.payload.widgetId, "entities", stepIndex]);
                return state.setIn(
                    [action.payload.widgetId, "entities", stepIndex],
                    stepData.mergeDeep(action.payload)
                );
            }
        }
        return state;
    },
    STEP_REMOVE_COLLECTION_ITEM_FROM_STORE: (state, action) => {
        let widgetId = action.payload.widget || action.payload.widgetId;
        var steps = state.getIn([widgetId, "entities"]);
        if (steps) {
            var stepIndex = steps.findIndex(step => {
                let classifiers = step.get("class") ? step.get("class") : new Immutable.List([]);

                return classifiers.includes(action.payload.step);
            });
            if (stepIndex > -1) {
                var stepData = state.getIn([widgetId, "entities", stepIndex]);
                if (stepData) {
                    var options = action.payload.options
                        ? action.payload.options.options
                        : { index: -1 };
                    var collection = stepData.getIn(action.payload.path);
                    if (collection) {
                        var newCollection = collection.delete(options.index);
                        var newStepData = stepData.setIn(action.payload.path, newCollection);

                        return state.setIn([widgetId, "entities", stepIndex], newStepData);
                    }
                }
            }
        }

        return state;
    }
};
